import {AuthApi, Api_url} from "./api/NETWORKCONSTS";
import {refreshToken} from "./api/account.api";
import {authActions} from "../helper/redux/actions/authActions";
import {sagaActions} from "../helper/redux/actions/SagaActions";

export function setupAxios(axios, store) {
    let isRefreshing = false;
    let failedQueue = [];

    const processQueue = (error, token = null) => {
        failedQueue.forEach((prom) => {
            if (error) {
                prom.reject(error);
            } else {
                prom.resolve(token);
            }
        });
        failedQueue = [];
    };

    const isAuthError = (status) => status === 401 || status === 417;

    axios.interceptors.request.use(
        (config) => {
            const isAuthEndpoint =
                config.url?.includes("v1/account/refreshToken") ||
                config.url?.includes("v1/account/login") ||
                config.url?.includes("v1/account/sendsms");

            if (isAuthEndpoint) {
                // هدر Authorization نباید به اندپوینت‌های احراز هویت ارسال شود
                if (typeof config.headers?.delete === "function") {
                    config.headers.delete("Authorization");
                    config.headers.delete("authorization");
                } else if (config.headers) {
                    delete config.headers.Authorization;
                    delete config.headers.authorization;
                }
            } else {
                const {auth: {token} = {}} = store.getState();
                if (token) {
                    if (typeof config.headers?.set === "function") {
                        config.headers.set("Authorization", "Bearer " + token);
                    } else {
                        config.headers = config.headers || {};
                        config.headers.Authorization = "Bearer " + token;
                    }
                }
            }
            config.baseURL = AuthApi.BASEURL;
            return config;
        },
        (err) => {
            console.error("Axios request error:", err);
            return Promise.reject(err);
        }
    );

    axios.interceptors.response.use(
        (response) => response,
        async function (error) {
            const originalRequest = error.config;

            // اگر درخواست نامعتبر است یا خطایی غیر از 401/417 رخ داده
            if (!originalRequest || !isAuthError(error?.response?.status)) {
                return Promise.reject(error);
            }

            // اگر اندپوینت رفرش توکن خود با خطا مواجه شده باشد، از لوپ بی‌نهایت جلوگیری شود
            if (
                originalRequest.url?.includes(Api_url.Account.REFRESH_TOKEN) ||
                originalRequest.url?.includes("v1/account/refreshToken")
            ) {
                return Promise.reject(error);
            }

            // اگر قبلاً برای این درخواست تلاش مجدد انجام شده، از لوپ جلوگیری شود
            if (originalRequest._retry) {
                return Promise.reject(error);
            }

            if (isRefreshing) {
                originalRequest._retry = true;
                return new Promise(function (resolve, reject) {
                    failedQueue.push({resolve, reject});
                })
                    .then((newToken) => {
                        if (typeof originalRequest.headers?.set === "function") {
                            originalRequest.headers.set("Authorization", "Bearer " + newToken);
                        } else if (originalRequest.headers) {
                            originalRequest.headers.Authorization = "Bearer " + newToken;
                        }
                        return axios(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const authState = store.getState()?.auth;
            const rToken =
                authState?.refreshToken ||
                authState?.user?.RefreshToken ||
                authState?.user?.refreshToken;

            const stripAuthHeader = (req) => {
                if (typeof req.headers?.delete === "function") {
                    req.headers.delete("Authorization");
                    req.headers.delete("authorization");
                } else if (req.headers) {
                    delete req.headers.Authorization;
                    delete req.headers.authorization;
                }
            };

            const isPublicEndpoint =
                !originalRequest.url?.includes("/user/") &&
                !originalRequest.url?.includes("/basket/") &&
                !originalRequest.url?.includes("/invoice/") &&
                !originalRequest.url?.includes("/wallet/");

            if (!rToken) {
                isRefreshing = false;
                store.dispatch(sagaActions.RequestLogout());
                if (isPublicEndpoint) {
                    stripAuthHeader(originalRequest);
                    return axios(originalRequest);
                }
                return Promise.reject(error);
            }

            return new Promise((resolve, reject) => {
                refreshToken(rToken)
                    .then((result) => {
                        const resData = result.data?.Data;
                        const newToken =
                            resData?.Token ||
                            resData?.token ||
                            (typeof resData === "string" ? resData : null);
                        const newRefreshToken =
                            resData?.RefreshToken || resData?.refreshToken;

                        if (newToken) {
                            store.dispatch(authActions.SetToken(newToken));
                            if (newRefreshToken) {
                                store.dispatch(authActions.SetRefreshToken(newRefreshToken));
                            }
                            processQueue(null, newToken);

                            if (typeof originalRequest.headers?.set === "function") {
                                originalRequest.headers.set("Authorization", "Bearer " + newToken);
                            } else if (originalRequest.headers) {
                                originalRequest.headers.Authorization = "Bearer " + newToken;
                            }
                            resolve(axios(originalRequest));
                        } else {
                            throw new Error("Invalid token in refresh response");
                        }
                    })
                    .catch((refreshError) => {
                        processQueue(refreshError, null);
                        store.dispatch(sagaActions.RequestLogout());
                        if (isPublicEndpoint) {
                            stripAuthHeader(originalRequest);
                            return resolve(axios(originalRequest));
                        }
                        reject(refreshError);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }
    );
}

